import script from "./PSITView.vue?vue&type=script&setup=true&lang=js"
export * from "./PSITView.vue?vue&type=script&setup=true&lang=js"

import "./PSITView.vue?vue&type=style&index=0&id=9baa3c4c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9baa3c4c"]])

export default __exports__